import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="29" height="21" viewBox="0 0 29 21" xmlns="http://www.w3.org/2000/svg" {...props}><g fillRule="nonzero" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M19.667 6.625l7.75 7.75M27.416 6.625l-7.75 7.75M2.58 15.02a.999.999 0 01-.997-1.001V6.98c0-.553.44-1.002.997-1.002h4.17l7.104-4.52v18.083L6.75 15.02H2.58z" /></g></svg>);